import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ApplicationTrackingService {

  constructor(public http: HttpClient) {
    
  }

  public paymentDetails(id): Observable<any> {
    return this.http.get(environment.BASE_URL_DAS + `das/paymentDetails/${id}`)
  }

  public checkPaymentMethod(id): Observable<any> {
    return this.http.get(environment.BASE_URL_DAS + `das/checkPaymentMethod/${id}/1`)
  }

  getDasTrackingData(applicationId): Observable<any> {
    return this.http.get(
      environment.BASE_URL_PCD + `api/das/${applicationId}/tracking`
    );
  }

  getDesTrackingData(applicationId,acronym):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`${acronym}/getTracking/`+applicationId);
  }

 
  downloadDASAppForm(payload,formName):Observable<any>
  {
    return this.http.post(environment.BASE_URL_DAS+`das/generateDasReport/${formName}`,payload)

  }

  downloadPdf(payload,formName):Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'misc/reportGeneration/DAS/'+formName+'/pdf',payload);
  }

  public getTemplateList(acronym):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`${acronym}/getTemplateList`);
  }
}
